'use client';

import React from 'react';
import SiteHeader from '@/components/site/Header';
import SiteHero from '@/components/site/Hero';
import SiteServices from '@/components/site/Services';
import SiteVitrine from '@/components/site/Vitrine';
import SiteAbout from '@/components/site/About';
import SiteContact from '@/components/site/Contact';
import SiteFooter from '@/components/site/Footer';
import Script from 'next/script';

export default function LandingPage() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Eliz Ateliê",
    "image": "https://elizatelier.com.br/icon.png",
    "@id": "https://elizatelier.com.br",
    "url": "https://elizatelier.com.br",
    "telephone": "+5579988086893",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Rua Américo Curvelo, 253, Loja C",
      "addressLocality": "Aracaju",
      "addressRegion": "SE",
      "postalCode": "49020-260",
      "addressCountry": "BR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": -10.932822, // Approximate for Salgado Filho
      "longitude": -37.054366
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "09:00",
        "closes": "13:00"
      }
    ],
    "sameAs": [
      "https://www.instagram.com/elizatelieoficial/",
      "https://wa.me/5579988086893"
    ]
  };

  return (
    <div className="min-h-screen bg-background flex flex-col scroll-smooth">
      <Script
        id="structured-data"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <SiteHeader />
      
      <main className="flex-grow">
        <SiteHero />
        <SiteVitrine />
        <SiteServices />
        <SiteAbout />
        <SiteContact />
      </main>

      <SiteFooter />
    </div>
  );
}
